<template>
    <a @click="toggleItem()">
        {{ this.isOn ? this.onLabel : this.offLabel }}
    </a>
</template>

<script>
    export default {
        props: {
            item: String,
            initial: Boolean,
            onLabel: String,
            offLabel: String,
            route: String,
            setFavoriteHandler: Function,
        },
        data: function () {
            return {
                isOn: this.initial
            }
        },
        methods: {
            toggleItem() {
                if(this.route){
                    axios.post(this.route, {
                            'item' : this.item
                        }
                    ).then( (response) => {
                        this.isOn = response.data.is_on;
                    }).catch(function (error) {
                        // error management?
                        console.log(error);
                    });
                }
            }
        },
        mounted: function() {
        }
    };
</script>
